<div class="avatar" (click)="onClick()" [ngClass]="{'background': withBg}">
    <img src="{{ src }}" alt="{{ alt }}" [attr.width]="size" [attr.height]="size" loading="lazy" />
    <aa-action-circle class="white-on-yellow duotone" [faIcon]="'fal ' + icon" *ngIf="overloaded">
    </aa-action-circle>
</div>
